



import UMUM from '../library/umum'

export default {

  props: ["list_pemeriksa"],
  data() {
      return {
          UMUM: UMUM,
          mdl_status : false,
          mdl_viewKeterangan : false,

          form : {
            id : '',
            keterangan : '',
          },


          list_data : [],




      }
  },

  methods: {
    viewStatus : function(){

    },
    selectData(data) {
      // console.log(data);
      this.form.id = data.id;
      this.form.keterangan = data.keterangan
    }
  },

}
